import ModelCardWithActions from "./ModelCardWithActions";
export default ModelCardWithActions;
